<footer class="footer">
  <div class="footer__container">
    <p class="footer__copyright">{{ 'LAYOUT.FOOTER' | translate }}</p>
  </div>
</footer>
